import React from 'react'
import { debugError } from '../../utils/debug'

function FallbackMessage()
{
  return <div>Oops! The 3D canvas failed to render or is very slow. Please try refreshing the page or check back later.</div>
}

export class ErrorBoundary extends React.Component
{
  constructor(props)
  {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error)
  {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo)
  {
    debugError('[ErrorBoundary] Error caught:', error, errorInfo)
  }

  render()
  {
    if (this.state.hasError)
    {
      return <FallbackMessage />
    }

    return this.props.children
  }
}
